let HttpService = require('../services/http.service');

module.exports = {
  data() {
    return {
      loadingVisible: true,
      nextPage: null,
      sortBy: '',
      sortOrder: '',
      sortAttribute: '',
    };
  },
  methods: {
    fetchResource: function(params) {
      var self = this;
      self.loadingVisible = true;
      params = params || self.query || {};
      params.limit = 5;

      if (self.nextPage) {
        params.page = self.nextPage;
      }

      if (self.sortBy) {
        params.sortBy = self.sortBy;
      }

      HttpService.index(self.resource, params, function(response, error) {
        self.loadingVisible = false;
        if (error) {
          //Handle error
        } else {
          if (self.nextPage) {
            self[self.model] = self[self.model].concat(response.result.data);
          } else {
            self[self.model] = response.result.data;
          }
          self.nextPage = response.result.nextPage;

          if (self.sortOrderFix) {
            self[self.model].sort(function(a, b) {
              try {
                let submit_order = new Date(a.submittedAt).getTime() - new Date(b.submittedAt).getTime();
                let slot_order = new Date(a.slotDate).getTime() - new Date(b.slotDate).getTime();
                return slot_order || submit_order;
              } catch (e) {
                return -1;
              }
            });
          }
        }
      });
    },
    sort(order) {
      this.nextPage = null;
      if (this.sortAttribute === order) {
        this.sortOrder = this.sortOrder === 'desc' ? 'asc' : 'desc';
      } else {
        this.sortOrder = 'desc';
      }

      this.sortAttribute = order;
      this.sortBy = this.sortAttribute + '.' + this.sortOrder;
      this.fetchResource();
    },
    getSortClasses(attribute) {
      return [
        'table--col',
        {
          'is-active': this.sortAttribute === attribute,
          'is-decreasing': this.sortOrder === 'desc' && this.sortAttribute === attribute,
        },
      ];
    },
  },
  mounted() {
    this.fetchResource();
  },
};



// WEBPACK FOOTER //
// ./src/mixins/listResource.mixin.js